import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGetInvoices } from '@/modules/payment/apiHooks';
import { useBillingUtils } from '@/modules/payment/billing/logic';
import { Table, Typography } from '@/shared/components/atoms';

const InvoicesSection = () => {
  const { t } = useTranslation('payment');
  const { data } = useGetInvoices();
  const { getInvoicesColumns } = useBillingUtils();

  return (
    <div className='flex flex-col gap-24'>
      <div className='w-full border-xs border-neutralVariant-90'></div>
      <div className=''>
        <Typography weight='semiBold'>{t('billing-and-invoicing')}</Typography>
        <Typography className='text-surface-10' variant='caption'>
          {t('billing-and-invoicing-description')}
        </Typography>
      </div>
      <Table
        headCellClassName='text-start border-b-xs border-neutralVariant-90 text-surface-10 font-semi-bold'
        rowCellClassName='border-b-xs border-neutralVariant-90'
        headContainerClassName='!bg-background-neutral-99'
        tableWrapperClassName='!rounded-xl mb-24 border-xs border-outline-variant'
        data={data?.invoices ?? []}
        pagination={false}
        selection={false}
        columns={getInvoicesColumns()}
      />
    </div>
  );
};

export { InvoicesSection };
